module.exports = __webpack_public_path__ + "img/装饰金币_里侧@2x.fc8ab570.png";